var BrowsePaginationFooterPresenter, DealsPaginationFooterTemplate, DealsPaginationFooterView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BrowsePaginationFooterPresenter = require('../../../browse/common/presenters/pagination_footer');

DealsPaginationFooterTemplate = require('../../pagination_footer.html.mustache');

module.exports = DealsPaginationFooterView = (function(superClass) {
  extend(DealsPaginationFooterView, superClass);

  function DealsPaginationFooterView() {
    this.paginationClickHandler = bind(this.paginationClickHandler, this);
    return DealsPaginationFooterView.__super__.constructor.apply(this, arguments);
  }

  DealsPaginationFooterView.prototype.template = DealsPaginationFooterTemplate;

  DealsPaginationFooterView.prototype.events = {
    'click .pagination a': 'paginationClickHandler'
  };

  DealsPaginationFooterView.prototype.initialize = function() {
    if (this.fetchedDealCount == null) {
      this.fetchedDealCount = 0;
    }
    return this.presenter = null;
  };

  DealsPaginationFooterView.prototype.updatePresenter = function(dealSearch) {
    var dealCount, endingIndex, nextPageSize, number, page, paginationFooter, startingIndex, totalDealCount, totalPages;
    page = dealSearch.page;
    number = page.number, totalPages = page.totalPages, dealCount = page.dealCount, nextPageSize = page.nextPageSize, totalDealCount = page.totalDealCount, startingIndex = page.startingIndex, endingIndex = page.endingIndex;
    this.fetchedDealCount += dealCount;
    paginationFooter = _.extend({}, BrowsePaginationFooterPresenter.toHash({
      requestURL: window.location.pathname,
      query: Groupon.Utils.unparam(),
      currentPageNumber: number,
      totalPages: totalPages,
      nextPageSize: nextPageSize,
      fetchedDealCount: this.fetchedDealCount,
      totalDealCount: totalDealCount,
      startingIndex: startingIndex,
      endingIndex: endingIndex
    }, Groupon.expandingPaginationEnabled, {
      I18n: I18n
    }, true));
    this.presenter = {
      paginationFooter: paginationFooter
    };
    return this;
  };

  DealsPaginationFooterView.prototype.render = function() {
    return this.$el.html(this.toHtml());
  };

  DealsPaginationFooterView.prototype.toHtml = function() {
    return this.template.render(this.presenter);
  };

  DealsPaginationFooterView.prototype.removeLoadingState = function() {
    return $('.pagination button').removeClass('loading');
  };

  DealsPaginationFooterView.prototype.paginationClickHandler = function(event) {
    event.preventDefault();
    return this.trigger('click:paginationLink', event);
  };

  return DealsPaginationFooterView;

})(Backbone.View);

//# sourceMappingURL=data:application/json;base64,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
